var BrowsePaginationFooterPresenter, DealsPaginationFooterTemplate, DealsPaginationFooterView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BrowsePaginationFooterPresenter = require('../../../browse/common/presenters/pagination_footer');

DealsPaginationFooterTemplate = require('../../pagination_footer.html.mustache');

module.exports = DealsPaginationFooterView = (function(superClass) {
  extend(DealsPaginationFooterView, superClass);

  function DealsPaginationFooterView() {
    this.paginationClickHandler = bind(this.paginationClickHandler, this);
    return DealsPaginationFooterView.__super__.constructor.apply(this, arguments);
  }

  DealsPaginationFooterView.prototype.template = DealsPaginationFooterTemplate;

  DealsPaginationFooterView.prototype.events = {
    'click .pagination a': 'paginationClickHandler'
  };

  DealsPaginationFooterView.prototype.initialize = function() {
    if (this.fetchedDealCount == null) {
      this.fetchedDealCount = 0;
    }
    return this.presenter = null;
  };

  DealsPaginationFooterView.prototype.updatePresenter = function(dealSearch) {
    var dealCount, endingIndex, nextPageSize, number, page, paginationFooter, startingIndex, totalDealCount, totalPages;
    page = dealSearch.page;
    number = page.number, totalPages = page.totalPages, dealCount = page.dealCount, nextPageSize = page.nextPageSize, totalDealCount = page.totalDealCount, startingIndex = page.startingIndex, endingIndex = page.endingIndex;
    this.fetchedDealCount += dealCount;
    paginationFooter = _.extend({}, BrowsePaginationFooterPresenter.toHash({
      requestURL: window.location.pathname,
      query: Groupon.Utils.unparam(),
      currentPageNumber: number,
      totalPages: totalPages,
      nextPageSize: nextPageSize,
      fetchedDealCount: this.fetchedDealCount,
      totalDealCount: totalDealCount,
      startingIndex: startingIndex,
      endingIndex: endingIndex
    }, Groupon.expandingPaginationEnabled, {
      I18n: I18n
    }, true));
    this.presenter = {
      paginationFooter: paginationFooter
    };
    return this;
  };

  DealsPaginationFooterView.prototype.render = function() {
    return this.$el.html(this.toHtml());
  };

  DealsPaginationFooterView.prototype.toHtml = function() {
    return this.template.render(this.presenter);
  };

  DealsPaginationFooterView.prototype.removeLoadingState = function() {
    return $('.pagination button').removeClass('loading');
  };

  DealsPaginationFooterView.prototype.paginationClickHandler = function(event) {
    event.preventDefault();
    return this.trigger('click:paginationLink', event);
  };

  return DealsPaginationFooterView;

})(Backbone.View);

//# sourceMappingURL=data:application/json;base64,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
